"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _moduleRegistry = _interopRequireDefault(require("./module-registry"));
var _baseLazyComponent = _interopRequireDefault(require("./base-lazy-component"));
var ReactLazyComponent = /*#__PURE__*/function (_BaseLazyComponent) {
  (0, _inheritsLoose2["default"])(ReactLazyComponent, _BaseLazyComponent);
  function ReactLazyComponent(props, manifest) {
    var _this;
    _this = _BaseLazyComponent.call(this, props, manifest) || this;
    _this.state = {
      component: null
    };
    return _this;
  }
  var _proto = ReactLazyComponent.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;
    this.resourceLoader.then(function () {
      var component = _moduleRegistry["default"].component(_this2.manifest.component);
      _this2.setState({
        component: component
      });
    });
  };
  _proto.render = function render() {
    return this.renderComponent();
  };
  return ReactLazyComponent;
}(_baseLazyComponent["default"]);
var _default = exports["default"] = ReactLazyComponent;